export class DeleteMembershipPlanModel {
    public productId : string;
}